import { InjectionToken } from '@angular/core';

export interface SharedAuthSessionOptions {
  allowBackgroundRefresh?: boolean;
  isSilentRefresh?: boolean;
}

export interface SharedAuthSessionManager {
  ensureValidSession(options: SharedAuthSessionOptions): Promise<boolean>;
}

export interface SharedInvalidSessionHandler {
  handleInvalidSession(): void;
}

export const SHARED_AUTH_SESSION_MANAGER =
  new InjectionToken<SharedAuthSessionManager>('SHARED_AUTH_SESSION_MANAGER');

export const SHARED_INVALID_SESSION_HANDLER =
  new InjectionToken<SharedInvalidSessionHandler>('SHARED_INVALID_SESSION_HANDLER');
